import { Sort, SortOrder as ServerSortOrder } from '@spike/model';
import clsx from 'clsx';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { FunctionComponent, PropsWithChildren } from 'react';
import styles from './HeaderTableColumn.module.scss';
import HeaderTableSorter from './HeaderTableSorter';
import { Sorter, SortOrder } from './sorting';

interface HeaderTableColumnProps extends PropsWithChildren {
    columnSorter?: Sorter;
    selectedSorter?: Sorter | null;
    sortColumn?: string;
    selectedSort?: Sort | null;
    className?: string;
    onSort?: (sorter: Sorter) => void;
    onServerSort?: (sort: Sort) => void;
}

export const HeaderTableColumn: FunctionComponent<HeaderTableColumnProps> = props => {
    const serverSorted = props.sortColumn !== undefined;
    const serverSelected = serverSorted && props.selectedSort?.column === props.sortColumn;

    const clickHandler = () => {
        if (props.sortColumn !== undefined) {
            props.onServerSort?.({
                column: props.sortColumn,
                order:
                    props.selectedSort?.column === props.sortColumn &&
                    props.selectedSort.order === ServerSortOrder.ASCENDANT
                        ? ServerSortOrder.DESCENDANT
                        : ServerSortOrder.ASCENDANT
            });
            return;
        }

        if (props.columnSorter !== undefined) {
            if (props.columnSorter.id === props.selectedSorter?.id) {
                props.onSort?.({
                    ...props.columnSorter,
                    order:
                        props.selectedSorter.order === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING
                });
            } else {
                props.onSort?.({ ...props.columnSorter });
            }
        }
    };

    return (
        <TableHeaderCell className={props.className}>
            <div
                className={clsx(styles.container, {
                    [styles.sortable]: props.columnSorter !== undefined || serverSorted
                })}
                onClick={clickHandler}
            >
                {props.children}
                {serverSelected ? (
                    <HeaderTableSorter
                        order={
                            props.selectedSort?.order === ServerSortOrder.DESCENDANT
                                ? SortOrder.DESCENDING
                                : SortOrder.ASCENDING
                        }
                    />
                ) : props.columnSorter && props.columnSorter.id === props.selectedSorter?.id ? (
                    <HeaderTableSorter order={props.selectedSorter?.order} />
                ) : null}
            </div>
        </TableHeaderCell>
    );
};

export default HeaderTableColumn;
